import React from 'react';
import { FormattedMessage } from 'react-intl';

import { GalleryAddress } from '@definitions/artworks.types';
import { PointTitle } from '@components/PDP/pdp.styles';
import { GalleryAddressBlock } from '@components/galleryAddressBlock';

import { Container } from './artworkGallery.styles';

export interface ArtworkGalleryProps {
  gallery: GalleryAddress;
}

export const ArtworkGallery = ({ gallery }: ArtworkGalleryProps) => (
  <Container>
    <PointTitle>
      <FormattedMessage id="artworkGallery.pointTitle" defaultMessage="② Offered by:" />
    </PointTitle>
    <GalleryAddressBlock {...gallery} />
  </Container>
);
